"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var ArrowLeft = function ArrowLeft(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.5,12c-0.001-0.662,0.283-1.292,0.78-1.729L16.432,0.46c0.781-0.656,1.946-0.554,2.602,0.228 c0.634,0.756,0.562,1.877-0.163,2.545l-9.752,8.579c-0.104,0.091-0.114,0.249-0.023,0.353c0.007,0.008,0.015,0.016,0.023,0.023 l9.752,8.579c0.781,0.656,0.883,1.821,0.228,2.602c-0.656,0.781-1.821,0.883-2.602,0.228c-0.022-0.018-0.043-0.037-0.065-0.057 L5.284,13.732C4.786,13.294,4.501,12.663,4.5,12z",
    stroke: "none",
    fill: fill,
    strokeWidth: "0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
ArrowLeft.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
ArrowLeft.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = ArrowLeft;